import {useQuery} from "@apollo/client";
import {GetRoleDocument, UserRole} from "generated/graphql";

export const useGetRole = () => {
  const { data } = useQuery(GetRoleDocument);
  return data?.role.role ?? UserRole.Normal;
}